import { modalRoute } from '@/router/helpers/modalRoute'

export const settingsRoutes = [
  {
    path: 'settings',
    component: () => import('@/components/settings/Index.vue'),
    children: [
      {
        path: '',
        name: 'Settings',
        redirect: {
          name: 'PersonalData',
        },
      },
      {
        path: 'personal-data',
        children: [
          {
            path: '',
            name: 'PersonalData',
            component: () => import('@/components/settings/personal/Index.vue'),
            children: [
              modalRoute(
                ':type/edit',
                'EditPersonalData',
                () => import('@/components/settings/personal/modals/Edit.vue'),
              ),
              modalRoute(
                ':type',
                'DeletePersonalData',
                () => import('@/components/settings/modals/Delete.vue'),
              ),
            ],
          },
        ],
      },
      {
        path: 'security',
        name: 'Security',
        component: () => import('@/components/settings/security/Index.vue'),
        children: [
          modalRoute(
            'change-password',
            'ChangePassword',
            () =>
              import(
                '@/components/settings/security/modals/ChangePassword.vue'
              ),
          ),
          modalRoute(
            'enable',
            'EnableMfa',
            () => import('@/components/settings/security/modals/EnableMfa.vue'),
          ),
          modalRoute(
            'disable',
            'DisableMfa',
            () =>
              import('@/components/settings/security/modals/DisableMfa.vue'),
          ),
          modalRoute(
            'manage-passkeys',
            'ManagePasskeys',
            () =>
              import(
                '@/components/settings/security/modals/ManagePasskeys.vue'
              ),
          ),
          modalRoute(
            'add-member',
            'AddMember',
            () => import('@/components/users/modals/Add.vue'),
          ),
        ],
      },
      {
        path: 'notifications',
        name: 'Notifications',
        component: () =>
          import('@/components/settings/notifications/Index.vue'),
      },
      {
        path: 'integrations',
        children: [
          {
            path: '',
            name: 'Integrations',
            component: () =>
              import('@/components/settings/integrations/Index.vue'),
            children: [
              modalRoute(
                'create-jwt',
                'CreateJWT',
                () =>
                  import(
                    '@/components/settings/integrations/modals/CreateJWT.vue'
                  ),
                {
                  meta: {
                    permissions: ['authCreate'],
                  },
                },
              ),
              modalRoute(
                'webhook/setup',
                'WebhookSetup',
                () =>
                  import(
                    '@/components/settings/integrations/webhook/modals/SetupWebhook.vue'
                  ),
              ),
            ],
          },
          {
            path: 'webhook',
            name: 'WebhookView',
            component: () =>
              import(
                '@/components/settings/integrations/webhook/WebhookView.vue'
              ),
            children: [
              modalRoute(
                'edit',
                'WebhookEdit',
                () =>
                  import(
                    '@/components/settings/integrations/webhook/modals/SetupWebhook.vue'
                  ),
              ),
              modalRoute(
                'public-jwk',
                'WebhookPublicJwk',
                () =>
                  import(
                    '@/components/settings/integrations/webhook/modals/PublicJwk.vue'
                  ),
              ),
              modalRoute(
                'event/:id',
                'WebhookEventDetails',
                () =>
                  import(
                    '@/components/settings/integrations/webhook/modals/EventDetails.vue'
                  ),
              ),
            ],
          },
        ],
      },
      {
        path: 'account',
        children: [
          {
            path: '',
            name: 'CloseAccount',
            component: () => import('@/components/settings/closure/Index.vue'),
            children: [
              modalRoute(
                ':type',
                'CloseAccountModal',
                () => import('@/components/settings/modals/Delete.vue'),
              ),
            ],
          },
        ],
      },
    ],
  },
]
